"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfig = exports.withConfig = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const DefaultConfig_1 = require("./DefaultConfig");
const withConfig = (Context) => (WrappedComponent) => class WithConfigValues extends react_1.Component {
    render() {
        return ((0, jsx_runtime_1.jsx)(Context.Consumer, { children: (config) => (0, jsx_runtime_1.jsx)(WrappedComponent, { ...this.props, config: config }, void 0) }, void 0));
    }
};
exports.withConfig = withConfig;
const useConfig = (Context) => {
    const context = (0, react_1.useContext)(Context);
    return {
        ...context,
        createApiUrl: DefaultConfig_1.createApiUrl,
    };
};
exports.useConfig = useConfig;
